import { Heading, Stack, Text } from "@chakra-ui/react";
import * as React from "react";
import Markdown from "react-markdown";

export function StyledMarkdown({ children }: { children: string }) {
  return (
    <Markdown
      components={{
        h2: ({ children }) => (
          <Heading as="h2" size="md" mt="4" mb="2">
            {children}
          </Heading>
        ),
        p: ({ children }) => <Text mb="3">{children}</Text>,
        ul: ({ children }) => (
          <Stack as="ul" gap="1" mb="3" pl="4">
            {children}
          </Stack>
        ),
        li: ({ children }) => (
          <Text as="li" display="list-item">
            {children}
          </Text>
        ),
      }}
    >
      {children}
    </Markdown>
  );
}
